let $body;
let $currentToggle;
let $currentMenu;
const toggle = '.Dropdown__toggle';
const toggleClassShow = 'Dropdown__toggle--show';
const menuClassShow = 'Dropdown__menu--show';

function openDropdownMenu(e) {
  e.preventDefault();

  $currentToggle = $(this);
  $currentMenu = $currentToggle.next('.Dropdown__menu');

  if ($currentToggle.hasClass(toggleClassShow)) {
    closeDropdownMenu();
  } else {
    $currentMenu.addClass(menuClassShow);
    $currentToggle.addClass(toggleClassShow);

    $body
      .on('keyup', closeDropdownMenuOnEsc)
      .on('click', closeDropdownMenuOnOutsideClick);
  }
}

function closeDropdownMenu() {
  $currentToggle.removeClass(toggleClassShow);
  $currentMenu.removeClass(menuClassShow);

  $body
    .off('keyup', closeDropdownMenuOnEsc)
    .off('click', closeDropdownMenuOnOutsideClick);
}

function closeDropdownMenuOnEsc(e) {
  if(e.key === 'Escape') {
    closeDropdownMenu();
  }
}

function closeDropdownMenuOnOutsideClick(e) {
  const target = $(e.target);

  if (!target.closest('.Dropdown').length && $currentToggle.hasClass(toggleClassShow)) {
    closeDropdownMenu();
  }
}

export default function() {
  $body = $('body');

  $body.on('click', toggle, openDropdownMenu);
}



// WEBPACK FOOTER //
// ./scripts/components/dropdown.js